<template>
  <div v-if="bet">
    <table>
      <tr style="width: 100%;">
        <td style="width: 10%;" @click="hideBet">
        </td>
        <td style="width: 80%;">
          <div class="center" @click="showBet()">
            <table style="border-collapse: collapse;">
              <tr>
                <td :class="'stat-bar-'+betStatus" rowspan="4">
                </td>
                <td>
                  <div>
                    <table>
                      <tr>
                        <td class="bet-title" colspan="2">
                          {{bet.keyword}}
                        </td>
                      </tr>
                      <tr>
                        <td class="bet-info">
                          <div>
                            <div>
                              <span class= "bet-info-title">Status: </span>
                              <span class= "bet-info-text">{{betStatus}}</span>
                            </div>
                            <div>
                              <span class= "bet-info-title">Created At: </span>
                              <span class= "bet-info-text">{{getLocalDate(bet.created_at)}}</span>
                            </div>
                            <div>
                              <span class= "bet-info-title">The Pot: </span>
                              <span class= "bet-info-text">{{formatCurrency(bet.total)}}</span>
                            </div>
                            <div v-if="showPlaced">
                              <span class= "bet-info-title">Participants count: </span>
                              <span class= "bet-info-text">{{bet.participantsCount}}</span>
                            </div>
                          </div>
                        </td>
                        <td class="bet-option-box">
                          <div class="bet-options">
                            <div v-bind:key="option.name" v-for="option in bet.bet_options" :class="{ 'bet-option winner' : bet.winning_option_number === option.option_number , 'bet-option' : bet.winning_option_number != option.option_number}">{{option.name}}
                              <span class="bet-multiplier">({{formatCurrency(option.multiplier)}}x)</span>
                              <span v-if="bet.winning_option_number === option.option_number">(WINNER)</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </td>
                <td :class="'stat-bar-'+betStatus" rowspan="4">
                </td>
              </tr>
            </table>
            <div>
              <transition name="slide-fade">
                <div v-if="showPlaced">
                  <br />
                  <placeBet v-if="$store.state.currentUser&&betStatus=='Open'" v-bind:options="bet.bet_options"  v-on:callPlaceBet="callPlaceBet"></placeBet>
                  <login-btn v-if="!$store.state.currentUser&&betStatus=='Open'" style="display: inline-block;">Login to place a bet</login-btn>
                  <div v-if="myBets.length > 0">
                    <div style="font-weight:bold;">My Bets</div>
                    <placed-bets v-if="showPlaced" :bet_id="bet.id" :placed_bets="myBets" size="mini"></placed-bets>
                  </div>
                  <div style="font-weight:bold;">Placed Bets</div>
                  <placed-bets v-if="showPlaced" :bet_id="bet.id" :placed_bets="placedBets"></placed-bets>
                </div>
              </transition>
            </div>
          </div>
        </td>
        <td style="width: 10%;" @click="hideBet">
        </td>
      </tr>
    </table>
    <br>
  </div>
</template>

<script>
import placeBet from './Place-Bet'
export default {
  name: 'bet',
  props: ['betId'],
  async created () {
    this.$store.dispatch('fetchBet', this.betId)
  },
  components: {
    placeBet
  },
  data () {
    return {
      showPlaced: false,
      placedFetched: false
    }
  },
  computed: {
    bet () {
      return this.$store.state.bets[this.betId]
    },
    placedBets () {
      // console.log('STORE', this.$store.state.placedBets)
      return this.$store.state.placedBets[this.betId] || []
    },
    myBets () {
      // console.log('STORE', this.$store.state.placedBets)
      return this.$store.state.myBets[this.betId] || []
    },
    betStatus () {
      /*
        'created': 1,
        'completed': 2,
        'pending': 3,
        'canceled': 4
      */
      if (this.bet.status === 2) {
        return 'Completed'
      } else if (this.bet.status === 4) {
        return 'Canceled'
      } else if (this.bet.status === 5) {
        return 'Closed'
      } else {
        return 'Open'
      }
    }
  },
  methods: {
    showBet: function () {
      if (!this.placedFetched && !this.showPlaced) {
        this.$store.dispatch('fetchPlacedBets', this.betId)
        this.showPlaced = true
      }
    },
    hideBet () {
      this.showPlaced = false
    },
    callPlaceBet (amount, option) {
      const betIdx = this.betId
      this.$store.dispatch('placeBet', {amount, betIdx, option})
    },
    getLocalDate (datex) {
      var localDate = new Date(datex.toString())
      return (`${localDate.getHours()}:${localDate.getMinutes()}:${localDate.getSeconds().toString().length === 1 ? ('0' + (localDate.getSeconds())) : localDate.getSeconds()}`)
    }
  }
}
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped>

table {
  width:100%;
}

.stat-bar-Open{
    width: 1%;
    height: 100%;
    background-color: rgb(88, 255, 88);
    box-shadow: 0px 0px 8px rgb(57, 199, 0);
  }
.stat-bar-Closed{
  width: 1%;
  height: 100%;
  background-color: rgb(255, 242, 61);
  box-shadow: 0px 0px 8px rgb(255, 238, 0);
}
.stat-bar-Completed{
  width: 1%;
  height: 100%;
  background-color: rgb(54, 135, 228);
}
.bet-title{
  font-size: 34px;
  font-weight: bold;
  padding: 5px;
  border: 1px rgba(255, 255, 255, 0.15) solid;
  background-color: rgba(0, 0, 0, 0.2);
}
.bet-info{
  font-size: 20px;
  text-align: left;
  padding: 10px;
}
.bet-info-title{
 font-weight: bold;
 font-size: 18px;
}
.bet-info-text{
  font-size: 16px;
  font-weight: 100;
  color: rgb(204, 204, 204);
}
.bet-option-box{
  width: 70%;
  border-left: 1px rgba(255, 255, 255, 0.2) solid;
  font-size: 20px;
}
.bet-option-header{
  font-size: 24px;
  text-align: center;
  border-bottom: 1px rgba(255, 255, 255, 0.2) solid;
  padding: 5px;
}
.bet-options{
  display: flex;
  flex-wrap: wrap;
  justify-content:space-evenly;
  padding: 5px;
}
.bet-option{
  padding: 8px;
  background-color: rgba(0, 0, 0, 0.2);
  margin: 5px;
  border-radius: 5px;
}
.bet-option.winner{
  border: 2px #b62626 solid;
}

.bet-multiplier{
  color: gray;
  font-size: 16px;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.center {
  display: table;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  margin-bottom: 10px;
  background-color: rgba(0, 0, 0, 0.3);
  transition: outline 0.5s ease;
  outline: 3px #b6262600 solid;
}

.center:hover {
  outline: 3px #b62626 solid;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>


// WEBPACK FOOTER //
// src/components/Bet.vue